module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b",
    attrs: {
      "id": "ch03"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Contents#ch-03"
    }
  }, [_c('span', {
    staticClass: "line"
  }, [_vm._v("THESE TOOLISH THINGS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('i', [_vm._v("Anyone stuck behind bars without a file can tell you that there’s nothing like the proper hand tool for the proper job. Here’s what happened once our ancestors figured that out.")])])])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('b', [_vm._v("HAMMERHEADS")])])]), _vm._v(" "), _c('p', {
    staticClass: "spx"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space"
  }), _vm._v("Hammers have been around for millions of years—ever since folks smashed objects with heavy stones called “hammerstones.”")]), _vm._v(" "), _c('p', {
    staticClass: "spx"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space"
  }), _vm._v("The earliest hafted hammers, hammers with wooden handles tied on, appeared about 6000–4000 B.C.")]), _vm._v(" "), _c('p', {
    staticClass: "spx"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space"
  }), _vm._v("Materials to make the hammerhead kept up with man’s progress—from stone to flint to bronze. And, by the Iron Age (which began in about 200 B.C.), the hammerhead was a strong, handy tool that didn’t change much until the modern age of steel alloys.")]), _vm._v(" "), _c('p', {
    staticClass: "spx"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space"
  }), _vm._v("That toolbox staple, the claw hammer, was designed by the Romans.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('b', [_vm._v("GETTING THE AX")])])]), _vm._v(" "), _c('p', {
    staticClass: "spx"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space"
  }), _vm._v("Like hammers, the first axes with handles date back to around 6000 B.C. They had blades of stone or flint.")]), _vm._v(" "), _c('p', {
    staticClass: "spx"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space"
  }), _vm._v("In 1000 B.C., axes were cast in copper or bronze.")]), _vm._v(" "), _c('p', {
    staticClass: "spx"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space"
  }), _vm._v("By the Iron Age, axes were cast with a hole to take a wooden handle.")]), _vm._v(" "), _c('p', {
    staticClass: "spx"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space"
  }), _vm._v("The Roman ax was much like the one we use today.")]), _vm._v(" "), _c('p', {
    staticClass: "spx"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space"
  }), _vm._v("Double-bladed axes, like those used by lumberjacks, have been popular for centuries.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('b', [_vm._v("OLD SAWS")])])]), _vm._v(" "), _c('p', {
    staticClass: "spx"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space"
  }), _vm._v("The first saws were pieces of flint with jagged edges; they were essential for cutting up an animal and removing its meat.")]), _vm._v(" "), _c('p', {
    staticClass: "spx"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space"
  }), _vm._v("The Bronze Age (about 3300–700 B.C.) brought saws with long, copper blades and teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "spx"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space"
  }), _vm._v("The ancient Egyptians could saw stone with their copper saws; there are even saw marks on the Great Pyramids!")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('span')]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('b', [_vm._v("PULLING FAT OUT OF THE FIRE")])])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "spx"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space"
  }), _vm._v("Fire was fine. But how to pull food out of the fire before it burned? The answer came around 2000 B.C., in Europe, with the earliest pliers—nothing more than a couple of sticks, which soon evolved into crude tongs.")]), _vm._v(" "), _c('p', {
    staticClass: "spx"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space"
  }), _vm._v("By 500 B.C., blacksmiths had discovered the advantage of leverage, making pliers with long handles and short teeth for gripping—less effort for more grip.")]), _vm._v(" "), _c('p', {
    staticClass: "spx"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space"
  }), _vm._v("In Roman times, pliers did various jobs from pulling nails to cutting.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('b', [_vm._v("SCREWING AROUND WITH HISTORY")])])]), _vm._v(" "), _c('p', {
    staticClass: "spx"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space"
  }), _vm._v("Wooden screws were invented by the 5th-century-B.C. Greek philosopher Archytas of Tarentum. He is credited with inventing the pulley and—of all things—the baby rattle!")]), _vm._v(" "), _c('p', {
    staticClass: "spx"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space"
  }), _vm._v("By the 1400s, screws had gone metal, popping up on everything from armor to furniture.")]), _vm._v(" "), _c('p', {
    staticClass: "spx"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space"
  }), _vm._v("The screwdriver, as we know it, was historically documented for the first time in the 15th century in Germany—designed for use in carpentry.")]), _vm._v(" "), _c('p', {
    staticClass: "spx"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space"
  }), _vm._v("Screwdrivers gained ground in the 1850s, when metal screws were manufactured en masse.")]), _vm._v(" "), _c('p', {
    staticClass: "spx"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space"
  }), _vm._v("The namesake of the screwdriver with the little "), _c('i', [_vm._v("x")]), _vm._v(" on top was traveling salesman Henry M. Phillips of Portland, Oregon. He invented his “Phillips head” screwdriver in the 1930s to make car manufacturing go more smoothly. It took time to center a standard screw and screwdriver; so, Phillips designed a screw with an "), _c('i', [_vm._v("x")]), _vm._v(" on the head, which would center automatically. He made the "), _c('i', [_vm._v("x")]), _vm._v(" very shallow, so that once the screw was in place the screwdriver—even the automatic ones used by carmakers—would pop out instead of stripping the screw.")]), _vm._v(" "), _c('p', {
    staticClass: "spx"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space"
  }), _vm._v("The 1936 Cadillac featured Phillips screws.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('b', [_vm._v("WRENCHING DEVELOPMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "spx"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space"
  }), _vm._v("The basic wrench is an American invention used as a lever for tightening or turning objects. The first basic wrench was patented in 1835 by Solymon Merrick of Springfield, Massachusetts.")])]), _c('p', {
    staticClass: "spx"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("•"), _c('span', {
    staticClass: "space"
  })]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("The huge pipe wrench, which bad guys wield in movies, was invented in 1870 by steamboat fireman Daniel C. Stillson. He got rich from the royalties.")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "center-box"
  }, [_c('span', [_c('b', [_vm._v("The custom of coloring Easter eggs dates back to the ancient Egyptians and Persians.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('b', [_vm._v("DOING THE DRILL")])])]), _vm._v(" "), _c('p', {
    staticClass: "spx"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space"
  }), _vm._v("The first Stone Age drills were low-tech affairs, consisting of a stick with abrasive sand poured under the tip. Early drillers rolled the stick back and forth between their palms. And after a while—after a long while—the sand wore a hole into whatever they were drilling.")]), _vm._v(" "), _c('p', {
    staticClass: "spx"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space"
  }), _vm._v("In the 1400s, braces were used to hold objects on one side and poke holes into them on the other.")]), _vm._v(" "), _c('p', {
    staticClass: "spx"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space"
  }), _vm._v("The biggest drilling breakthrough came with the advent of the screw (see above), which let you drill a hole into something while removing the drilling residue.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('b', [_vm._v("FILE THIS")])])]), _vm._v(" "), _c('p', {
    staticClass: "spx"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space"
  }), _vm._v("The first known files were pieces of sharkskin. Superabrasive, they were used to smooth out rough surfaces of stone, wood, or bone.")]), _vm._v(" "), _c('p', {
    staticClass: "spx"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space"
  }), _vm._v("The first metal files were made of bronze, and the Romans used them to help sharpen their saws.")]), _vm._v(" "), _c('p', {
    staticClass: "spx"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space"
  }), _vm._v("Leonardo da Vinci once sketched a file-making machine, but he never took the time to build it (being a pretty busy guy already).")]), _vm._v(" "), _c('p', {
    staticClass: "centeraa"
  }, [_c('span', [_vm._v("* * * * *")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Hand tools discovered in northern Kenya in 1969 are estimated to be about 2,600,000 years old.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("“One only needs two tools in life: WD-40 to make things go, and duct tape to make them stop.”—G. Weilacher")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("“Men have become fools with their tools.”—Thomas Elisha Stewart")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b343324","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter03.vue
// module id = 87
// module chunks = 0